import { useSyncExternalStore } from 'react';

const MEDIA_QUERY = '(min-width: 768px)';
const DEFAULT_MATCH = true;

let mql: MediaQueryList | null = null;
let mqlHandler: ((event: MediaQueryListEvent) => void) | null = null;
let currentMatch = DEFAULT_MATCH;
const listeners = new Set<() => void>();

function ensureMediaQuery() {
  if (typeof window === 'undefined') return;
  if (mql) return;
  mql = window.matchMedia(MEDIA_QUERY);
  currentMatch = mql.matches;
  mqlHandler = (event) => {
    currentMatch = event.matches;
    listeners.forEach((listener) => listener());
  };
  mql.addEventListener('change', mqlHandler);
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  ensureMediaQuery();
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  ensureMediaQuery();
  return currentMatch;
}

function getServerSnapshot() {
  return DEFAULT_MATCH;
}

export function useIsDesktop() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
